"use strict";

require("core-js/modules/es6.object.assign");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setConfig = exports.config = void 0;
exports.config = {
  onError: function onError(e) {
    return console.error(e);
  }
};

var setConfig = function setConfig(conf) {
  Object.assign(exports.config, conf);
};

exports.setConfig = setConfig;